function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var PeerService = require('saito-js/lib/peer_service')["default"];
var SaitoOverlay = require('../../lib/saito/ui/saito-overlay/saito-overlay');
var AppSettings = require('./lib/modtools-settings');
var modtoolsIndex = require('./index');
var SaitoContacts = require('../../lib/saito/ui/modals/saito-contacts/saito-contacts');
var WhitelistTemplate = require('./lib/add-whitelist.template');
var jsonTree = require('json-tree-viewer');
var Base58 = require('base-58');
var secp256k1 = require('secp256k1');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var ModTools = /*#__PURE__*/function (_ModTemplate) {
  //
  // blacklist and whitelist format
  //
  // {
  //	publicKey : add ,
  //	moderator : [moderator] ,
  //	duration : duration ,
  //	created_at : new Date().getTime() ,
  //	hop : (hop+1)
  // }
  //
  // duration = -1 is forever, otherwise length in ms
  //

  function ModTools(app) {
    var _app$options;
    var _this;
    _classCallCheck(this, ModTools);
    _this = _callSuper(this, ModTools, [app]);
    _this.app = app;
    _this.name = 'Modtools';
    _this.appname = 'ModTools';
    _this.slug = 'modtools';
    _this.description = 'Module for managing and customizing wallet and application moderation tools';
    _this["class"] = 'utility';
    _this.categories = 'Core Moderation';
    _this.status = 'prod';
    _this.icon = 'fas fa-eye-slash';
    _this.prune_after = 200000000; // ~2 day
    //this.prune_after = 120000; // ~2 minute
    _this.max_hops = 2; // stop blacklisting after N hops
    // Use 'testing' only on loopback hosts; missing configuration uses the production hash.
    var endpoint = (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.server) === null || _app$options === void 0 ? void 0 : _app$options.endpoint;
    var hostname = '';
    if (app.BROWSER) {
      hostname = window.location.hostname.toLowerCase();
    } else {
      var endpoint_host = typeof endpoint === 'string' ? endpoint : (endpoint === null || endpoint === void 0 ? void 0 : endpoint.host) || '';
      if (endpoint_host) {
        try {
          hostname = new URL(endpoint_host.includes('://') ? endpoint_host : "http://".concat(endpoint_host)).hostname.toLowerCase();
        } catch (_unused) {
          // Invalid endpoints keep the production hash.
        }
      }
    }
    var use_testing_password = ['localhost', '127.0.0.1', '[::1]'].includes(hostname);
    _this.admin_credential_hash = use_testing_password ? '61cc98e42ded96807806bf1620e13c4e6a1b85068cad93382a2e3107c269aefe' : 'cceb1c83976a46634021ca252a218a53ae882788d9507741db89f6582fc17233';
    _this.styles = [];

    //
    // stores the objects
    //
    _this.whitelist = [];
    _this.blacklist = [];
    _this.permissions = {};

    //
    // searchable publickeys, nothing more
    //
    _this.whitelisted_publickeys = [];
    _this.blacklisted_publickeys = [];
    _this.modtools_peer_key = '';
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(ModTools, _ModTemplate);
  return _createClass(ModTools, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app) {
        var _this2 = this;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _superPropGet(ModTools, "initialize", this, 3)([app]);
            case 1:
              this.load();
              this.app.connection.on('saito-blacklist', /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
                  var data, c, newtx, _t;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.p = _context.n) {
                      case 0:
                        if (obj !== null && obj !== void 0 && obj.publicKey) {
                          _context.n = 1;
                          break;
                        }
                        return _context.a(2);
                      case 1:
                        data = {
                          publicKey: obj.publicKey,
                          moderator: (obj === null || obj === void 0 ? void 0 : obj.moderator) || _this2.publicKey,
                          duration: (obj === null || obj === void 0 ? void 0 : obj.duration) || _this2.prune_after,
                          created_at: new Date().getTime(),
                          hop: 0
                        }; // Pop-up warning if banning someone who is in our keychain?
                        if (!_this2.app.keychain.returnKey(obj.publicKey, true)) {
                          _context.n = 3;
                          break;
                        }
                        _context.n = 2;
                        return sconfirm("".concat(_this2.app.keychain.returnUsername(obj.publicKey), " is in your keychain, are you sure you want to block them?"));
                      case 2:
                        c = _context.v;
                        if (c) {
                          _context.n = 3;
                          break;
                        }
                        return _context.a(2);
                      case 3:
                        //
                        // first we blacklist the address
                        //
                        _this2.blacklistAddress(data);
                        _context.p = 4;
                        _context.n = 5;
                        return _this2.createBlacklistTransaction(data);
                      case 5:
                        newtx = _context.v;
                        _context.n = 6;
                        return _this2.sendModtoolsPeerTransaction(newtx);
                      case 6:
                        _context.n = 8;
                        break;
                      case 7:
                        _context.p = 7;
                        _t = _context.v;
                        console.error('ModTools blacklist peer send failed:', _t);
                      case 8:
                        return _context.a(2);
                    }
                  }, _callee, null, [[4, 7]]);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
              this.app.connection.on('saito-whitelist', /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(obj) {
                  var data, newtx, _t2;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        if (obj !== null && obj !== void 0 && obj.publicKey) {
                          _context2.n = 1;
                          break;
                        }
                        return _context2.a(2);
                      case 1:
                        data = {
                          publicKey: obj.publicKey,
                          moderator: (obj === null || obj === void 0 ? void 0 : obj.moderator) || _this2.publicKey,
                          duration: (obj === null || obj === void 0 ? void 0 : obj.duration) || _this2.prune_after,
                          created_at: new Date().getTime(),
                          hop: 0
                        }; //
                        // first we whitelist the address
                        //
                        _this2.whitelistAddress(data);
                        _context2.p = 2;
                        _context2.n = 3;
                        return _this2.createWhitelistTransaction(data);
                      case 3:
                        newtx = _context2.v;
                        _context2.n = 4;
                        return _this2.sendModtoolsPeerTransaction(newtx);
                      case 4:
                        _context2.n = 6;
                        break;
                      case 5:
                        _context2.p = 5;
                        _t2 = _context2.v;
                        console.error('ModTools whitelist peer send failed:', _t2);
                      case 6:
                        return _context2.a(2);
                    }
                  }, _callee2, null, [[2, 5]]);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              this.app.connection.on('saito-unblacklist', /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(address) {
                  var newtx, _t3;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.p = _context3.n) {
                      case 0:
                        _this2.unblacklistAddress(address);
                        _context3.p = 1;
                        _context3.n = 2;
                        return _this2.createUnBlacklistTransaction(address);
                      case 2:
                        newtx = _context3.v;
                        _context3.n = 3;
                        return _this2.sendModtoolsPeerTransaction(newtx);
                      case 3:
                        _context3.n = 5;
                        break;
                      case 4:
                        _context3.p = 4;
                        _t3 = _context3.v;
                        console.error('ModTools unblacklist peer send failed:', _t3);
                      case 5:
                        return _context3.a(2);
                    }
                  }, _callee3, null, [[1, 4]]);
                }));
                return function (_x4) {
                  return _ref3.apply(this, arguments);
                };
              }());
              this.app.connection.on('saito-unwhitelist', /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(address) {
                  var newtx, _t4;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.p = _context4.n) {
                      case 0:
                        _this2.unwhitelistAddress(address);
                        _context4.p = 1;
                        _context4.n = 2;
                        return _this2.createUnWhitelistTransaction(address);
                      case 2:
                        newtx = _context4.v;
                        _context4.n = 3;
                        return _this2.sendModtoolsPeerTransaction(newtx);
                      case 3:
                        _context4.n = 5;
                        break;
                      case 4:
                        _context4.p = 4;
                        _t4 = _context4.v;
                        console.error('ModTools unwhitelist peer send failed:', _t4);
                      case 5:
                        return _context4.a(2);
                    }
                  }, _callee4, null, [[1, 4]]);
                }));
                return function (_x5) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (this.app.BROWSER) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              this.header = new SaitoHeader(this.app, this);
              _context6.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.addComponent(this.header);
              //this.styles = [`/${this.returnSlug()}/style.css`];
              _context6.n = 3;
              return _superPropGet(ModTools, "render", this, 3)([]);
            case 3:
              this.attachEvents();
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      if (!this.browser_active) {
        return;
      }
      var pw = '';
      if (document.getElementById('whitelist')) {
        document.getElementById('whitelist').onclick = function (e) {
          var _document$getElementB;
          var overlay = new SaitoOverlay(_this3.app, _this3);
          overlay.show(WhitelistTemplate(_this3));
          (_document$getElementB = document.getElementById('saito-overlay-form-password')) === null || _document$getElementB === void 0 || _document$getElementB.focus();
          var form = document.getElementById('register-whitelist-key-template');
          if (form) {
            form.onsubmit = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(event) {
                var _document$getElementB2, _document$getElementB3;
                var key, credential, sudo_mode, data, newtx, _document$getElementB4, _document$getElementB5, _t5;
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.p = _context7.n) {
                    case 0:
                      event.preventDefault();
                      key = ((_document$getElementB2 = document.getElementById('saito-overlay-form-input')) === null || _document$getElementB2 === void 0 || (_document$getElementB2 = _document$getElementB2.value) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.trim()) || '';
                      pw = ((_document$getElementB3 = document.getElementById('saito-overlay-form-password')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.value) || pw;
                      if (!key) {
                        key = _this3.publicKey;
                      }
                      if (_this3.app.crypto.isPublicKey(key)) {
                        _context7.n = 1;
                        break;
                      }
                      siteMessage('Invalid public key', 2500);
                      return _context7.a(2);
                    case 1:
                      credential = _this3.app.crypto.hash(pw);
                      sudo_mode = credential === _this3.admin_credential_hash;
                      if (!(!sudo_mode && !_this3.whitelisted_publickeys.includes(_this3.publicKey))) {
                        _context7.n = 2;
                        break;
                      }
                      siteMessage('Invalid admin password', 2500);
                      return _context7.a(2);
                    case 2:
                      data = {
                        publicKey: key,
                        moderator: _this3.publicKey,
                        duration: -1,
                        created_at: new Date().getTime(),
                        hop: 0
                      };
                      _context7.p = 3;
                      _context7.n = 4;
                      return _this3.createWhitelistTransaction(data, credential);
                    case 4:
                      newtx = _context7.v;
                      _context7.n = 5;
                      return _this3.sendModtoolsPeerTransaction(newtx);
                    case 5:
                      _this3.whitelistAddress(data, sudo_mode);
                      if (sudo_mode) {
                        (_document$getElementB4 = document.getElementById('pw-lock')) === null || _document$getElementB4 === void 0 || _document$getElementB4.classList.remove('fa-lock');
                        (_document$getElementB5 = document.getElementById('pw-lock')) === null || _document$getElementB5 === void 0 || _document$getElementB5.classList.add('fa-lock-open');
                      }
                      overlay.remove();
                      _this3.refreshWhitelistUI();
                      siteMessage('Address added to whitelist', 2500);
                      _context7.n = 7;
                      break;
                    case 6:
                      _context7.p = 6;
                      _t5 = _context7.v;
                      console.error('ModTools whitelist failed:', _t5);
                      siteMessage((_t5 === null || _t5 === void 0 ? void 0 : _t5.message) || 'Unable to whitelist address', 2500);
                    case 7:
                      return _context7.a(2);
                  }
                }, _callee7, null, [[3, 6]]);
              }));
              return function (_x6) {
                return _ref5.apply(this, arguments);
              };
            }();
          }
        };
      }
      var contacts = new SaitoContacts(this.app, this, true);
      if (document.getElementById('unwhitelist')) {
        document.getElementById('unwhitelist').onclick = function (e) {
          contacts.title = 'Whitelisted Accounts';
          contacts.multi_button = 'Remove from Whitelist';
          contacts.callback = /*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(keys) {
              var _iterator, _step, key, newtx, _t6;
              return _regenerator().w(function (_context8) {
                while (1) switch (_context8.p = _context8.n) {
                  case 0:
                    _iterator = _createForOfIteratorHelper(keys);
                    _context8.p = 1;
                    _iterator.s();
                  case 2:
                    if ((_step = _iterator.n()).done) {
                      _context8.n = 6;
                      break;
                    }
                    key = _step.value;
                    _context8.n = 3;
                    return _this3.createUnWhitelistTransaction(key, _this3.app.crypto.hash(pw));
                  case 3:
                    newtx = _context8.v;
                    _context8.n = 4;
                    return _this3.sendModtoolsPeerTransaction(newtx);
                  case 4:
                    _this3.unwhitelistAddress(key);
                  case 5:
                    _context8.n = 2;
                    break;
                  case 6:
                    _context8.n = 8;
                    break;
                  case 7:
                    _context8.p = 7;
                    _t6 = _context8.v;
                    _iterator.e(_t6);
                  case 8:
                    _context8.p = 8;
                    _iterator.f();
                    return _context8.f(8);
                  case 9:
                    _this3.refreshWhitelistUI();
                  case 10:
                    return _context8.a(2);
                }
              }, _callee8, null, [[1, 7, 8, 9]]);
            }));
            return function (_x7) {
              return _ref6.apply(this, arguments);
            };
          }();
          contacts.render(window.whitelist);
        };
      }
      if (document.getElementById('unblacklist')) {
        document.getElementById('unblacklist').onclick = function (e) {
          contacts.title = 'Blacklisted Accounts';
          contacts.multi_button = 'Remove from Blacklist';
          contacts.callback = /*#__PURE__*/function () {
            var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(keys) {
              var _iterator2, _step2, key, newtx, _t7;
              return _regenerator().w(function (_context9) {
                while (1) switch (_context9.p = _context9.n) {
                  case 0:
                    _iterator2 = _createForOfIteratorHelper(keys);
                    _context9.p = 1;
                    _iterator2.s();
                  case 2:
                    if ((_step2 = _iterator2.n()).done) {
                      _context9.n = 6;
                      break;
                    }
                    key = _step2.value;
                    _context9.n = 3;
                    return _this3.createUnBlacklistTransaction(key, _this3.app.crypto.hash(pw));
                  case 3:
                    newtx = _context9.v;
                    _context9.n = 4;
                    return _this3.sendModtoolsPeerTransaction(newtx);
                  case 4:
                    _this3.unblacklistAddress(key);
                  case 5:
                    _context9.n = 2;
                    break;
                  case 6:
                    _context9.n = 8;
                    break;
                  case 7:
                    _context9.p = 7;
                    _t7 = _context9.v;
                    _iterator2.e(_t7);
                  case 8:
                    _context9.p = 8;
                    _iterator2.f();
                    return _context9.f(8);
                  case 9:
                    return _context9.a(2);
                }
              }, _callee9, null, [[1, 7, 8, 9]]);
            }));
            return function (_x8) {
              return _ref7.apply(this, arguments);
            };
          }();
          contacts.render(window.blacklist);
        };
      }
    }
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      services.push(new PeerService(null, 'modtools'));
      return services;
    }
  }, {
    key: "refreshWhitelistUI",
    value: function refreshWhitelistUI() {
      if (!this.app.BROWSER || !this.browser_active) {
        return;
      }
      var existing = document.getElementById('modtools-whitelist');
      if (!existing) {
        return;
      }
      var html = modtoolsIndex(this.app, this);
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.getElementById('modtools-whitelist');
      if (!next) {
        return;
      }
      existing.replaceWith(document.importNode(next, true));
      if (typeof window !== 'undefined') {
        window.whitelist = this.whitelisted_publickeys.slice();
      }
      this.attachEvents();
    }

    ////////////////////////
    // when peer connects //
    ////////////////////////
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(app, peer) {
        var service,
          modtools_self,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              service = _args0.length > 2 && _args0[2] !== undefined ? _args0[2] : {};
              modtools_self = this; //
              // modtools -- share whitelists / blacklists
              //
              if (service.service === 'modtools') {
                this.modtools_peer_key = peer.publicKey;

                //
                // Make sure our connected node is not! blacklisted!
                //
                if (this.app.BROWSER) {
                  if (this.isBlacklisted(peer.publicKey)) {
                    this.unblacklistAddress(peer.publicKey);
                  }
                }

                //
                // If we trust the peer (node or browser),
                // request the black/white lists and add them to our own
                //
                if (this.canPeerModerate(peer.publicKey)) {
                  app.network.sendRequestAsTransaction('modtools', {
                    request: 'load'
                  }, function (res) {
                    var _res$blacklist, _res$whitelist;
                    if (res !== null && res !== void 0 && (_res$blacklist = res.blacklist) !== null && _res$blacklist !== void 0 && _res$blacklist.length) {
                      modtools_self.addPeerBlacklist(peer.publicKey, res.blacklist);
                    }
                    if (res !== null && res !== void 0 && (_res$whitelist = res.whitelist) !== null && _res$whitelist !== void 0 && _res$whitelist.length) {
                      modtools_self.addPeerWhitelist(peer.publicKey, res.whitelist);
                    }
                  }, peer.publicKey);
                }
              }
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function onPeerServiceUp(_x9, _x0) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }() //
    // on-chain transactions
    //
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(blk, tx, conf) {
        var txmsg;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              if (!(Number(conf) == 0)) {
                _context1.n = 4;
                break;
              }
              txmsg = tx.returnMessage();
              if (!(txmsg.request == 'whitelist')) {
                _context1.n = 1;
                break;
              }
              _context1.n = 1;
              return this.receiveWhitelistTransaction(blk, tx, conf, this.app);
            case 1:
              if (!(txmsg.request == 'blacklist')) {
                _context1.n = 2;
                break;
              }
              _context1.n = 2;
              return this.receiveBlacklistTransaction(blk, tx, conf, this.app);
            case 2:
              if (!(txmsg.request == 'unwhitelist')) {
                _context1.n = 3;
                break;
              }
              _context1.n = 3;
              return this.receiveUnWhitelistTransaction(blk, tx, conf, this.app);
            case 3:
              if (!(txmsg.request == 'unblacklist')) {
                _context1.n = 4;
                break;
              }
              _context1.n = 4;
              return this.receiveUnBlacklistTransaction(blk, tx, conf, this.app);
            case 4:
              return _context1.a(2, 0);
          }
        }, _callee1, this);
      }));
      function onConfirmation(_x1, _x10, _x11) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }() //
    // off-chain transactions
    //
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          _txmsg$data,
          _txmsg$data2,
          ok,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              tx = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : null;
              peer = _args10.length > 2 ? _args10[2] : undefined;
              mycallback = _args10.length > 3 ? _args10[3] : undefined;
              if (!(tx == null)) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2, 0);
            case 1:
              txmsg = tx.returnMessage();
              if (txmsg !== null && txmsg !== void 0 && txmsg.request) {
                _context10.n = 2;
                break;
              }
              return _context10.a(2, 0);
            case 2:
              if (!(txmsg.request === 'modtools')) {
                _context10.n = 3;
                break;
              }
              if (!(((_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.request) === 'load')) {
                _context10.n = 3;
                break;
              }
              if (!mycallback) {
                _context10.n = 3;
                break;
              }
              mycallback({
                whitelist: this.whitelist,
                blacklist: this.blacklist
              });
              return _context10.a(2, 1);
            case 3:
              if (!(txmsg.request === 'whitelist' || txmsg.request === 'blacklist' || txmsg.request === 'unwhitelist' || txmsg.request === 'unblacklist')) {
                _context10.n = 13;
                break;
              }
              if (!this.app.BROWSER) {
                _context10.n = 4;
                break;
              }
              return _context10.a(2, 0);
            case 4:
              if (this.isValidSignedTransaction(tx)) {
                _context10.n = 5;
                break;
              }
              if (mycallback) {
                mycallback({
                  err: 'Invalid signature'
                });
              }
              return _context10.a(2, 1);
            case 5:
              if (!(txmsg.request === 'whitelist')) {
                _context10.n = 7;
                break;
              }
              _context10.n = 6;
              return this.receiveWhitelistTransaction(null, tx, 0, app);
            case 6:
              ok = this.isWhitelisted((_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.publicKey);
              if (mycallback) {
                mycallback(ok ? {
                  ok: 1
                } : {
                  err: 'Unauthorized'
                });
              }
              return _context10.a(2, 1);
            case 7:
              if (!(txmsg.request === 'blacklist')) {
                _context10.n = 9;
                break;
              }
              _context10.n = 8;
              return this.receiveBlacklistTransaction(null, tx, 0, app);
            case 8:
              if (mycallback) {
                mycallback({
                  ok: 1
                });
              }
              return _context10.a(2, 1);
            case 9:
              if (!(txmsg.request === 'unwhitelist')) {
                _context10.n = 11;
                break;
              }
              _context10.n = 10;
              return this.receiveUnWhitelistTransaction(null, tx, 0, app);
            case 10:
              if (mycallback) {
                mycallback({
                  ok: 1
                });
              }
              return _context10.a(2, 1);
            case 11:
              if (!(txmsg.request === 'unblacklist')) {
                _context10.n = 13;
                break;
              }
              _context10.n = 12;
              return this.receiveUnBlacklistTransaction(null, tx, 0, app);
            case 12:
              if (mycallback) {
                mycallback({
                  ok: 1
                });
              }
              return _context10.a(2, 1);
            case 13:
              return _context10.a(2, _superPropGet(ModTools, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee10, this);
      }));
      function handlePeerTransaction(_x12) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "sendModtoolsPeerTransaction",
    value: function sendModtoolsPeerTransaction(tx) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var peerKey = _this4.modtools_peer_key;
        if (!peerKey) {
          reject(new Error('ModTools peer unavailable'));
          return;
        }
        _this4.app.network.sendTransactionWithCallback(tx, function (res_tx) {
          var res = typeof (res_tx === null || res_tx === void 0 ? void 0 : res_tx.returnMessage) === 'function' ? res_tx.returnMessage() : res_tx;
          if (res !== null && res !== void 0 && res.err) {
            reject(new Error(res.err));
            return;
          }
          resolve(res || {});
        }, peerKey);
      });
    }
  }, {
    key: "isValidSignedTransaction",
    value: function isValidSignedTransaction(tx) {
      try {
        var _tx$from, _tx$getHashForSignatu;
        var signer = tx === null || tx === void 0 || (_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey;
        if (!(tx !== null && tx !== void 0 && tx.signature) || !signer) {
          return false;
        }
        if (typeof tx.generateHashForSignature === 'function') {
          tx.generateHashForSignature();
        }
        var hash = (_tx$getHashForSignatu = tx.getHashForSignature) === null || _tx$getHashForSignatu === void 0 ? void 0 : _tx$getHashForSignatu.call(tx);
        if (!hash) {
          return false;
        }
        var signingHash = Buffer.from(hash);
        var signature = Buffer.from(String(tx.signature), 'hex');
        var publicKey = Buffer.from(Base58.decode(String(signer)));
        if (signingHash.length !== 32 || signature.length !== 64 || publicKey.length !== 33) {
          return false;
        }
        return secp256k1.verify(signingHash, signature, publicKey);
      } catch (err) {
        return false;
      }
    }
  }, {
    key: "createBlacklistTransaction",
    value: function () {
      var _createBlacklistTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(data) {
        var newtx;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return this.app.wallet.createUnsignedTransaction(this.modtools_peer_key || '');
            case 1:
              newtx = _context11.v;
              newtx.msg = {
                module: this.name,
                request: 'blacklist',
                data: data
              };
              _context11.n = 2;
              return newtx.sign();
            case 2:
              return _context11.a(2, newtx);
          }
        }, _callee11, this);
      }));
      function createBlacklistTransaction(_x13) {
        return _createBlacklistTransaction.apply(this, arguments);
      }
      return createBlacklistTransaction;
    }()
  }, {
    key: "createWhitelistTransaction",
    value: function () {
      var _createWhitelistTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(data) {
        var credential,
          newtx,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              credential = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : null;
              _context12.n = 1;
              return this.app.wallet.createUnsignedTransaction(this.modtools_peer_key || '');
            case 1:
              newtx = _context12.v;
              newtx.msg = {
                module: this.name,
                request: 'whitelist',
                data: data
              };
              if (credential) {
                newtx.msg['credential'] = credential;
              }
              _context12.n = 2;
              return newtx.sign();
            case 2:
              return _context12.a(2, newtx);
          }
        }, _callee12, this);
      }));
      function createWhitelistTransaction(_x14) {
        return _createWhitelistTransaction.apply(this, arguments);
      }
      return createWhitelistTransaction;
    }()
  }, {
    key: "createUnBlacklistTransaction",
    value: function () {
      var _createUnBlacklistTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(address) {
        var credential,
          newtx,
          _args13 = arguments;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              credential = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : null;
              _context13.n = 1;
              return this.app.wallet.createUnsignedTransaction(this.modtools_peer_key || '');
            case 1:
              newtx = _context13.v;
              newtx.msg = {
                module: this.name,
                request: 'unblacklist',
                publicKey: address
              };
              if (credential) {
                newtx.msg['credential'] = credential;
              }
              _context13.n = 2;
              return newtx.sign();
            case 2:
              return _context13.a(2, newtx);
          }
        }, _callee13, this);
      }));
      function createUnBlacklistTransaction(_x15) {
        return _createUnBlacklistTransaction.apply(this, arguments);
      }
      return createUnBlacklistTransaction;
    }()
  }, {
    key: "createUnWhitelistTransaction",
    value: function () {
      var _createUnWhitelistTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(address) {
        var credential,
          newtx,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              credential = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : null;
              _context14.n = 1;
              return this.app.wallet.createUnsignedTransaction(this.modtools_peer_key || '');
            case 1:
              newtx = _context14.v;
              newtx.msg = {
                module: this.name,
                request: 'unwhitelist',
                publicKey: address
              };
              if (credential) {
                newtx.msg['credential'] = credential;
              }
              _context14.n = 2;
              return newtx.sign();
            case 2:
              return _context14.a(2, newtx);
          }
        }, _callee14, this);
      }));
      function createUnWhitelistTransaction(_x16) {
        return _createUnWhitelistTransaction.apply(this, arguments);
      }
      return createUnWhitelistTransaction;
    }()
  }, {
    key: "receiveBlacklistTransaction",
    value: function () {
      var _receiveBlacklistTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(blk, tx, conf, app) {
        var txmsg;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              txmsg = tx.returnMessage();
              if (this.canPeerModerate(tx.from[0].publicKey)) {
                this.blacklistAddress(txmsg.data);
              }
            case 1:
              return _context15.a(2);
          }
        }, _callee15, this);
      }));
      function receiveBlacklistTransaction(_x17, _x18, _x19, _x20) {
        return _receiveBlacklistTransaction.apply(this, arguments);
      }
      return receiveBlacklistTransaction;
    }()
  }, {
    key: "receiveWhitelistTransaction",
    value: function () {
      var _receiveWhitelistTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(blk, tx, conf, app) {
        var txmsg, sudo_mode;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              txmsg = tx.returnMessage();
              sudo_mode = (txmsg === null || txmsg === void 0 ? void 0 : txmsg.credential) === this.admin_credential_hash;
              if (this.canPeerModerate(tx.from[0].publicKey) || sudo_mode) {
                this.whitelistAddress(txmsg.data, sudo_mode);
              }
            case 1:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function receiveWhitelistTransaction(_x21, _x22, _x23, _x24) {
        return _receiveWhitelistTransaction.apply(this, arguments);
      }
      return receiveWhitelistTransaction;
    }()
  }, {
    key: "receiveUnBlacklistTransaction",
    value: function () {
      var _receiveUnBlacklistTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(blk, tx, conf, app) {
        var txmsg, sudo_mode, _iterator3, _step3, bl, _t8;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              txmsg = tx.returnMessage();
              sudo_mode = (txmsg === null || txmsg === void 0 ? void 0 : txmsg.credential) === this.admin_credential_hash;
              if (!this.isBlacklisted(txmsg.publicKey)) {
                _context17.n = 7;
                break;
              }
              _iterator3 = _createForOfIteratorHelper(this.blacklist);
              _context17.p = 1;
              _iterator3.s();
            case 2:
              if ((_step3 = _iterator3.n()).done) {
                _context17.n = 4;
                break;
              }
              bl = _step3.value;
              if (!(bl.publicKey == txmsg.publicKey)) {
                _context17.n = 3;
                break;
              }
              if (!(tx.isFrom(bl.moderator) || this.canPeerModerate(tx.from[0].publicKey) || sudo_mode)) {
                _context17.n = 3;
                break;
              }
              this.unblacklistAddress(txmsg.publicKey);
              return _context17.a(2);
            case 3:
              _context17.n = 2;
              break;
            case 4:
              _context17.n = 6;
              break;
            case 5:
              _context17.p = 5;
              _t8 = _context17.v;
              _iterator3.e(_t8);
            case 6:
              _context17.p = 6;
              _iterator3.f();
              return _context17.f(6);
            case 7:
              return _context17.a(2);
          }
        }, _callee17, this, [[1, 5, 6, 7]]);
      }));
      function receiveUnBlacklistTransaction(_x25, _x26, _x27, _x28) {
        return _receiveUnBlacklistTransaction.apply(this, arguments);
      }
      return receiveUnBlacklistTransaction;
    }()
  }, {
    key: "receiveUnWhitelistTransaction",
    value: function () {
      var _receiveUnWhitelistTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(blk, tx, conf, app) {
        var txmsg, sudo_mode, _iterator4, _step4, bl, _t9;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.p = _context18.n) {
            case 0:
              txmsg = tx.returnMessage();
              sudo_mode = (txmsg === null || txmsg === void 0 ? void 0 : txmsg.credential) === this.admin_credential_hash;
              if (!this.isWhitelisted(txmsg.publicKey)) {
                _context18.n = 7;
                break;
              }
              _iterator4 = _createForOfIteratorHelper(this.whitelist);
              _context18.p = 1;
              _iterator4.s();
            case 2:
              if ((_step4 = _iterator4.n()).done) {
                _context18.n = 4;
                break;
              }
              bl = _step4.value;
              if (!(bl.publicKey == txmsg.publicKey)) {
                _context18.n = 3;
                break;
              }
              if (!(tx.isFrom(bl.moderator) || this.canPeerModerate(tx.from[0].publicKey) || sudo_mode)) {
                _context18.n = 3;
                break;
              }
              this.unwhitelistAddress(txmsg.publicKey);
              return _context18.a(2);
            case 3:
              _context18.n = 2;
              break;
            case 4:
              _context18.n = 6;
              break;
            case 5:
              _context18.p = 5;
              _t9 = _context18.v;
              _iterator4.e(_t9);
            case 6:
              _context18.p = 6;
              _iterator4.f();
              return _context18.f(6);
            case 7:
              return _context18.a(2);
          }
        }, _callee18, this, [[1, 5, 6, 7]]);
      }));
      function receiveUnWhitelistTransaction(_x29, _x30, _x31, _x32) {
        return _receiveUnWhitelistTransaction.apply(this, arguments);
      }
      return receiveUnWhitelistTransaction;
    }()
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!container) {
        var overlay = new SaitoOverlay(this.app, this.mod);
        overlay.show("<div class=\"module-settings-overlay\"><h2>Moderation Settings</h2></div>");
        container = '.module-settings-overlay';
      }
      var as = new AppSettings(this.app, this, container);
      as.render();
    }

    /*
     * ModTools responds to events that are requested by the default moderation functions
     * in the Saito Wallet. These functions examine transactions and return 0 or 1 based
     * on whether the wallet should process those transactions.
     *
     * By default Saito will prevent any blacklisted transactions from being processed by
     * modules. This prevents those applications from even being handed to the modules for
     * processing. Applications can over-ride this default by extending ModTemplate and
     * overriding the default mod-filter function.
     *
     * This module contains some custom. It exists to allow users to customize the default
     * moderation functions either generically across ALL applications, or specifically to
     * individual applications and individual transactions.
     */
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this5 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var modtools_self = this;

      //
      // this moderation-level examines ALL transactions that are sent into specific
      // applications and checks to see if they are permitted. it will block applications
      // from being processed if they do not meet criteria.
      //
      // 1 = definitely show
      // -1 = definitely filter
      // 0 = no preference
      //
      /****
      *  NOTE: saito-modules handles the respondTo logic for saito-moderation-app
      * 
      if (type === 'saito-moderation-app') {
      return {
      filter_func: (app = null, tx = null) => {
      	if (tx == null || app == null) {
      		return 0;
      	}
      		//
      	// any app-specific moderation settings?
      	//
      	if (this.apps[app.name]) {
      		// permit everything
      		if (this.apps[app.name] == '*') {
      			return 1;
      		}
      	}
      	
      	if (this.apps[app.name]) {
      		// permit nothing
      		if (this.apps[app.name] == "!") { return -1; }
      	}
      	if (this.apps[app.name]) {
      		// permit fee-bearing txs
      		if (this.apps[app.name] == "$") { 
      			for (let i = 0; i < tx.from.length; i++) {
      				if (tx.from[i].amount > 0) {
      					return 1;
      				}
      			}
      			return -1;
      		}
      	}
      		return 0;
      }
      };
      }
      ****/
      if (type === 'saito-moderation-core') {
        return {
          filter_func: function filter_func() {
            var tx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            if (tx == null) {
              return 0;
            }
            if (!tx.from) {
              return 0;
            }
            if (!tx.from[0].publicKey) {
              return 0;
            }
            var add = tx.from[0].publicKey;
            if (_this5.whitelisted_publickeys.includes(add)) {
              return 1;
            }
            if (_this5.blacklisted_publickeys.includes(add)) {
              return -1;
            }
            return 0;
          }
        };
      }
      if (type === 'user-menu') {
        if (obj !== null && obj !== void 0 && obj.publicKey) {
          if (obj.publicKey !== this.publicKey) {
            if (!this.blacklisted_publickeys.includes(obj.publicKey)) {
              if (!this.whitelisted_publickeys.includes(obj.publicKey)) {
                return {
                  text: "Blacklist User",
                  icon: 'fa fa-ban',
                  rank: 60,
                  callback: function callback(app, publicKey) {
                    app.connection.emit('saito-blacklist', obj);
                  }
                };
              }
            }
          }
        }
      }
      return null;
    }
  }, {
    key: "unblacklistAddress",
    value: function unblacklistAddress(add) {
      for (var i = 0; i < this.blacklist.length; i++) {
        if (this.blacklist[i].publicKey == add) {
          this.blacklist.splice(i, 1);
          break;
        }
      }
      for (var _i = 0; _i < this.blacklisted_publickeys.length; _i++) {
        if (this.blacklisted_publickeys[_i] == add) {
          this.blacklisted_publickeys.splice(_i, 1);
          this.save();
          this.app.connection.emit('on-saito-blacklist-updated');
          return;
        }
      }
    }
  }, {
    key: "unwhitelistAddress",
    value: function unwhitelistAddress(add) {
      for (var i = 0; i < this.whitelist.length; i++) {
        if (this.whitelist[i].publicKey == add) {
          this.whitelist.splice(i, 1);
          break;
        }
      }
      for (var _i2 = 0; _i2 < this.whitelisted_publickeys.length; _i2++) {
        if (this.whitelisted_publickeys[_i2] == add) {
          this.whitelisted_publickeys.splice(_i2, 1);
          this.save();
          return;
        }
      }
    }
  }, {
    key: "canPeerModerate",
    value: function canPeerModerate() {
      var _this$permissions, _this$permissions2, _this$permissions3, _this$permissions4;
      var moderator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (((_this$permissions = this.permissions) === null || _this$permissions === void 0 ? void 0 : _this$permissions.mode) == 'none') {
        return 0;
      }
      if (this.whitelisted_publickeys.includes(moderator)) {
        return 1;
      }

      // Strict whitelist only for server node
      if (!this.app.BROWSER) {
        return 0;
      }
      if (this.blacklisted_publickeys.includes(moderator)) {
        return 0;
      }
      if (((_this$permissions2 = this.permissions) === null || _this$permissions2 === void 0 ? void 0 : _this$permissions2.mode) == 'server') {
        return 1;
      }
      if (((_this$permissions3 = this.permissions) === null || _this$permissions3 === void 0 ? void 0 : _this$permissions3.mode) == 'friends') {
        if (this.app.keychain.hasSharedSecret(moderator)) {
          return 1;
        }
        return 0;
      }
      if (((_this$permissions4 = this.permissions) === null || _this$permissions4 === void 0 ? void 0 : _this$permissions4.mode) == 'custom') {
        var key = this.app.keys.returnKey(moderator);
        if (key !== null && key !== void 0 && key.trusted_moderator) {
          return 1;
        }
      }
      return 0;
    }
  }, {
    key: "addPeerBlacklist",
    value: function addPeerBlacklist(moderator) {
      var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!list) {
        return;
      }

      // We don't accept moderation from someone blacklisted
      if (this.isBlacklisted(moderator)) {
        return 0;
      }

      // Verify black list from peer
      for (var i = 0; i < list.length; i++) {
        // we do not process a list that blacklists addresses we have whitelisted
        if (this.isWhitelisted(list[i].publicKey)) {
          return 0;
        }
        // we do not process a list that blacklists us
        if (list[i].publicKey == this.publicKey) {
          return 0;
        }
      }
      var updated = false;
      for (var _i3 = 0; _i3 < list.length; _i3++) {
        if (list[_i3].hop < this.max_hops) {
          if (this.blacklistAddress(list[_i3], false)) {
            updated = true;
          }
        }
      }
      if (updated) {
        this.app.connection.emit('on-saito-blacklist-updated');
      }
    }
  }, {
    key: "addPeerWhitelist",
    value: function addPeerWhitelist(moderator) {
      var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!list) {
        return;
      }
      for (var i = 0; i < list.length; i++) {
        if (list[i].hop < this.max_hops) {
          if (list[i].publicKey === this.publicKey) {
            this.app.connection.emit('modtools-on-server-whitelist');
          }

          // If I added, then removed, don't accept it just echoing back at me
          if (list[i].moderator !== this.publicKey) {
            this.whitelistAddress(list[i]);
          }
        }
      }
    }
  }, {
    key: "blacklistAddress",
    value: function blacklistAddress(data) {
      var emitUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // there is an edge-case where the first address will be added address-free, so checking and bailing
      if (!(data !== null && data !== void 0 && data.publicKey)) {
        return false;
      }
      var add = data.publicKey;
      if (add === this.publicKey) {
        // Don't blacklist myself
        return false;
      }
      if (!this.blacklisted_publickeys.includes(add)) {
        this.blacklisted_publickeys.push(add);
        if (data.moderator !== this.publicKey) {
          console.log('Add hop because using other moderator!');
          data.hop++;
          // reduce duration per hop
          // forever gets downgraded to default
          if (data.duration == -1) {
            data.duration = this.prune_after;
          } else {
            data.duration = data.duration / 2;
          }
        }
        this.blacklist.push(data);
        this.save();
        if (emitUpdate) {
          this.app.connection.emit('on-saito-blacklist-updated');
        }
        return true;
      }

      //
      // if we already have the entry, we can push its time stamp forward
      //
      var _iterator5 = _createForOfIteratorHelper(this.blacklist),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var entry = _step5.value;
          if (entry.publicKey === add) {
            entry.created_at = Math.max(entry.created_at, data.created_at);
            break;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this.save();
      return false;
    }
  }, {
    key: "whitelistAddress",
    value: function whitelistAddress(data) {
      var sudo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!(data !== null && data !== void 0 && data.publicKey)) {
        return;
      }
      var add = data.publicKey;
      if (!this.whitelisted_publickeys.includes(add)) {
        this.whitelisted_publickeys.push(add);
        if (data.moderator !== this.publicKey && !sudo) {
          data.hop++;
          // reduce duration per hop
          if (data.duration == -1) {
            data.duration = this.prune_after;
          } else {
            data.duration = data.duration / 2;
          }
        }
        this.whitelist.push(data);
      }

      //
      // if we already have the entry, we can push its time stamp forward
      //
      var _iterator6 = _createForOfIteratorHelper(this.whitelist),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var entry = _step6.value;
          if (entry.publicKey === add) {
            entry.created_at = Math.max(entry.created_at, data.created_at);
            break;
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      this.save();
    }

    // Will probably want to run this on a loop sometime, but we are pruning on initialize
    // which lets things stay on the black list a little bit longer...
  }, {
    key: "prune",
    value: function prune() {
      var current_time = new Date().getTime();
      for (var i = 0; i < this.blacklist.length; i++) {
        if (this.prune_after < current_time - this.blacklist[i].created_at) {
          this.blacklist.splice(i, 1);
        }
      }
    }
  }, {
    key: "updatePermissions",
    value: function updatePermissions() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (mode == '') {
        return;
      }
      var valid_tags = ['server', 'custom', 'friends', 'none'];
      if (!valid_tags.includes(mode)) {
        return;
      }
      this.permissions.mode = mode;
      this.save();
    }
  }, {
    key: "isBlacklisted",
    value: function isBlacklisted() {
      var add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.blacklisted_publickeys.includes(add)) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted() {
      var add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.whitelisted_publickeys.includes(add)) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "save",
    value: function save() {
      this.app.options.modtools = {};
      this.app.options.modtools.whitelist = this.whitelist;
      this.app.options.modtools.blacklist = this.blacklist;
      this.app.options.modtools.permissions = this.permissions;
      this.app.storage.saveOptions();

      //Broadcast that the black or white lists have changed
      this.app.connection.emit('modtools-lists-updated');
    }
  }, {
    key: "load",
    value: function load() {
      var _this$app$options$mod;
      if (!this.app.options.modtools) {
        this.app.options.modtools = {};
      }
      if (!this.app.options.modtools.whitelist) {
        this.app.options.modtools.whitelist = [];
      }
      if (!this.app.options.modtools.blacklist) {
        this.app.options.modtools.blacklist = [];
      }
      if (!this.app.options.modtools.permissions || (_this$app$options$mod = this.app.options.modtools.permissions) !== null && _this$app$options$mod !== void 0 && _this$app$options$mod.sync_blacklist) {
        this.app.options.modtools.permissions = {
          mode: 'server' // server = accept moderation lists from connected peers/servers
          // friends = anyone in my keylist
          // custom = manually tag keys as trusted moderators
          // none = I handle my own moderation
        };
      }

      // Backwards compatibility: older options used mode "public"
      if (this.app.options.modtools.permissions.mode === 'public') {
        this.app.options.modtools.permissions.mode = 'server';
      }
      if (!this.app.BROWSER) {
        this.app.options.modtools.permissions.mode = 'friends';
      }
      this.permissions = this.app.options.modtools.permissions;
      for (var i = 0; i < this.app.options.modtools.whitelist.length; i++) {
        if (this.verifyData(this.app.options.modtools.whitelist[i], true)) {
          var pk = this.app.options.modtools.whitelist[i].publicKey;
          if (!this.whitelisted_publickeys.includes(pk)) {
            this.whitelisted_publickeys.push(pk);
            this.whitelist.push(this.app.options.modtools.whitelist[i]);
          }
        }
      }
      for (var _i4 = 0; _i4 < this.app.options.modtools.blacklist.length; _i4++) {
        if (this.verifyData(this.app.options.modtools.blacklist[_i4], true)) {
          var _pk = this.app.options.modtools.blacklist[_i4].publicKey;
          if (!this.blacklisted_publickeys.includes(_pk)) {
            this.blacklisted_publickeys.push(_pk);
            this.blacklist.push(this.app.options.modtools.blacklist[_i4]);
          }
        }
      }
      this.save();
    }
  }, {
    key: "verifyData",
    value: function verifyData(obj) {
      var check_time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // Update data structure live
      if (!(obj !== null && obj !== void 0 && obj.publicKey)) {
        return false;
      }
      if (!(obj !== null && obj !== void 0 && obj.moderator)) {
        return false;
      }
      if (obj.publicKey == this.publicKey) {
        return false;
      }

      // Prune Old Listed Keys
      if (check_time) {
        var current_time = new Date().getTime();
        if (obj.duration >= 0) {
          if (obj.duration < current_time - obj.created_at) {
            return false;
          }
        }
      }
      return true;
    }

    /*
    Idea, prune_after should indicate prune after X time IFF we don't see said key
    */
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var modtools_self = this;
      expressapp.get('/' + encodeURI(this.returnSlug()), /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(req, res) {
          return _regenerator().w(function (_context19) {
            while (1) switch (_context19.n) {
              case 0:
                res.set('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context19.a(2, res.send(modtoolsIndex(app, modtools_self)));
            }
          }, _callee19);
        }));
        return function (_x33, _x34) {
          return _ref8.apply(this, arguments);
        };
      }());
      expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
    }
  }]);
}(ModTemplate);
module.exports = ModTools;